var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-copyright text-center py-4 mt-8 d-print-none"},[_vm._v("© "+_vm._s((new Date()).getFullYear())+"\n\n|\n"),_c('a',{attrs:{"href":_vm.$store.state.home.href,"target":"_blank"}},[_vm._v(_vm._s(_vm.$store.state.home.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }